import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { Iaddress, Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { Contatti } from 'my-lib-sanfelici/my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';
import { ContattiService } from 'my-lib-sanfelici';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';

@Component({
  selector: 'app-contatti-create',
  templateUrl: './contatti-create.component.html',
  styleUrls: ['./contatti-create.component.css']
})
export class ContattiCreateComponent implements OnInit {
contatto: Contatti;
id: string;
result;
user: Users;
address: Iaddress;
  constructor(
    private contattiservice: ContattiService,
    private usersservice: UsersService,
    public dialog: MatDialog,
    private router: Router,
    private db: AngularFirestore,

    private route: ActivatedRoute) { }
onSubmit() {
this.user.contatto=this.contatto;
this.usersservice.update(this.user).then(c => {
this.router.navigate(['/myuser', 'contatti', 'details', this.id]);
});
}
openDialog(): void {
  const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {

  });

  dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog was closed');
    console.log(result);
    if (result) {
      this.address = result;
      this.contatto.address =this.address;
      console.log(this.address);
    }
  });
}
  ngOnInit() {
this.id = this.route.snapshot.params.id;
this.usersservice.details(this.id).subscribe(u => {
  if (u) {
this.user = u;
if (u.contatto) {

    } else {
      this.contatto = {

        nome: null,
        cognome: null,
        fiscalcode: null,
         phone: null
        };
    }
  }
});


  }

}
